<div class="wrapper">

    <div class="row">
        <div class="col-sm-12 mb-2">
            <h1 class="pageTitle">{{pageTitle}}</h1>
            <div [innerHTML]="registerPageText"></div>
            <hr>
        </div>

        <div class="col-sm-12 col-md-7 col-lg-12 mt-4">

            <div class="card bb-panel">
                <form [formGroup]="customerForm" autocomplete="chrome-off" class="col-sm-12" role="form"
                    aria-label="registration form">

                    <span *ngIf="requiresFullRegistration">
                        <div class="form-group">
                            <label><span aria-hidden="true" class="form-field-required-marker">
                                    *</span> First name</label>
                            <input type="text" class="form-control" formControlName="first_name" role="textbox"
                                aria-label="first name input field">
                            <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                                <div *ngIf="form.first_name.errors.required" role="alert">First name is
                                    required</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label><span aria-hidden="true" class="form-field-required-marker">
                                    *</span> Last name</label>
                            <input type="text" class="form-control" formControlName="last_name" role="textbox"
                                aria-label="last name input field">
                            <div *ngIf="submitted && form.last_name.errors" class="invalid-feedback">
                                <div *ngIf="form.last_name.errors.required" role="alert">Last name is
                                    required</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label><span aria-hidden="true" class="form-field-required-marker">
                                    *</span> Email</label>
                            <input type="text" class="form-control" formControlName="email" role="textbox"
                                aria-label="email input field" autocapitalize="off" (change)="checkIfDupeUser()"
                                (input)="removeSpaces('email')" (keydown.space)="$event.preventDefault();"
                                (keydown.spacebar)="$event.preventDefault();">
                            <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                                <div *ngIf="form.email.errors.required" role="alert">Email address is
                                    required</div>
                                <div *ngIf="form.email.errors.mismatch" role="alert">Email address must match</div>
                                <div *ngIf="form.email.errors.pattern && !form.email.errors.required" role="alert">Email
                                    address invalid</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label><span aria-hidden="true" class="form-field-required-marker">
                                    *</span> Confirm email</label>
                            <input type="text" class="form-control" formControlName="confirmEmail" role="textbox"
                                aria-label="confirm email input field" autocapitalize="off"
                                (input)="removeSpaces('confirmEmail')" (keydown.space)="$event.preventDefault();"
                                (keydown.spacebar)="$event.preventDefault();">
                            <div *ngIf="submitted && form.confirmEmail.errors" class="invalid-feedback">
                                <div *ngIf="form.confirmEmail.errors.required" role="alert">Email address is
                                    required</div>
                                <div *ngIf="form.confirmEmail.errors.mismatch" role="alert">Email address must match
                                </div>
                                <div *ngIf="form.confirmEmail.errors.pattern && !form.confirmEmail.errors.required"
                                    role="alert">
                                    Email
                                    address invalid</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Contact number</label>
                            <input type="text" class="form-control" formControlName="mobile" role="textbox"
                                aria-label="Contact number input field" maxlength="11"
                                (keypress)="keyPressNumberField($event)">
                            <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
                                <div *ngIf="form.mobile.errors.required" role="alert">Contact number is
                                    required</div>
                                <div *ngIf="form.mobile.errors.minlength" role="alert">
                                    Please enter a vaild contact number</div>
                            </div>
                        </div>
                    </span>

                    <div>
                        <label><span aria-hidden="true" class="form-field-required-marker">
                                *</span> Password</label>
                        <div class="help-text" id="password-hint">
                            <p class="mb-0">Your password must have a minimum of 12 characters and must include at least 3 of the 4 below categories:</p>
                            <ul>
                                <li>
                                    Uppercase letters
                                </li>
                                <li>
                                    Lowercase letters
                                </li>
                                <li>
                                    Numbers
                                </li>
                                <li>
                                    Special characters (for example: #&/!*)
                                </li>
                            </ul>
                        </div>
                        <input [type]="hide ? 'password' : 'text'" class="form-control" formControlName="password"
                            autocomplete="new-password" role="textbox" aria-label="password input field" aria-describedby="password-hint">
                        <span class="eye-pos">
                            <mat-icon class="material-symbols-outlined eye" (click)="hide = false" *ngIf="hide">
                                visibility_off
                            </mat-icon>
                            <mat-icon class="material-symbols-outlined eye" (click)="hide = true" *ngIf="!hide">
                                visibility
                            </mat-icon>
                        </span>
                        <div class="invalid-feedback eye-compensation" *ngIf="submitted && form.password.errors">
                            <div *ngIf="form.password.errors.required" role="alert">Password is
                                required</div>
                            <div *ngIf="form.password.errors.pattern && !form.password.errors.required" role="alert">
                                Password must have a minimum of 12 characters, and including ones from at least 3 of these 4 categories:
                                <br>
                                • Uppercase letters
                                <br>
                                • Lowercase letters
                                <br>
                                • Numbers
                                <br>
                                • Special characters (for example: # & / ! *)
                            </div>
                        </div>
                    </div>

                    <div class="form-group eye-compensation">
                        <label><span aria-hidden="true" class="form-field-required-marker">
                                *</span> Confirm password</label>
                        <input [type]="hideConfirmPassword ? 'password' : 'text'" class="form-control"
                            formControlName="confirm_password" autocomplete="new-password" role="textbox"
                            aria-label="password input field">
                        <span class="eye-pos">
                            <mat-icon class="material-symbols-outlined eye" (click)="hideConfirmPassword = false"
                                *ngIf="hideConfirmPassword">
                                visibility_off
                            </mat-icon>
                            <mat-icon class="material-symbols-outlined eye" (click)="hideConfirmPassword = true"
                                *ngIf="!hideConfirmPassword">
                                visibility
                            </mat-icon>
                        </span>
                        <div *ngIf="submitted && form.confirm_password.errors"
                            class="invalid-feedback eye-compensation">
                            <div *ngIf="form.confirm_password.errors.required" role="alert">Password is
                                required</div>
                            <div *ngIf="form.confirm_password.errors.mismatch" role="alert">Passwords must match
                            </div>

                        </div>
                    </div>

                    <!-- <h5>{{'FORM.REGISTER.ADDITIONAL_HEADER' | translate}}</h5> -->
                    <!-- <hr /> -->
                    <!-- Customer questions -->
                    <!-- <div *ngFor="let question of customerQuestions;">
                <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_field'">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>

                    <input type="text" class="form-control" formControlName="{{question.reference}}" role="textbox"
                        attr.aria-label="{{question.name}} input field">
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}} is
                            required</div>


                    </div>
                </div>


                <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>
                    <textarea class="form-control" formControlName="{{question.reference}}"
                        attr.aria-label="{{question.name}} text area field"></textarea>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}} is
                            required</div>

                    </div>
                </div>

                <div class="form-group" *ngIf="question.visible && question.detail_type == 'number'">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>
                    <input type="search" class="form-control" formControlName="{{question.reference}}"
                        attr.aria-label="{{question.name}} input field" (keypress)="keyPressNumberField($event)"
                        maxlength="11">
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}} is
                            required</div>
                    </div>
                </div>

                <div
                    *ngIf="question.visible && question.detail_type == 'select' && question.id == bookingQuestionsConfig.schoolNameSelectionAccounts">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>
                    <input list="question.reference" formControlName="{{question.reference}}"
                        class="form-control selectpicker" (change)="onQuestionChange()">
                    <datalist id="question.reference">
                        <option *ngFor="let option of question.options" [value]="option.name">
                            {{option.name}}
                        </option>
                    </datalist>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                            {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                        </div>
                        <div *ngIf="form[question.reference].errors.selectedSchoolErr" role="alert">
                            {{form[question.reference].errors.selectedSchoolErr}}
                        </div>
                    </div>
                </div>

                <div class="form-group"
                    *ngIf="question.visible && question.detail_type == 'select' && question.id != bookingQuestionsConfig.schoolNameSelectionAccounts">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>
                    <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                        (change)="onQuestionChange()" attr.aria-label="{{question.name}}">

                        <option></option>
                        <option *ngFor="let option of question.options" [value]="option.name">
                            {{option.name}}
                        </option>

                    </select>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}} is
                            required</div>
                    </div>
                </div>

                <div class="form-group" *ngIf="question.visible && question.detail_type == 'date'">
                    <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                            *</span> {{question.name}}</label>
                    <input matInput formControlName="{{question.reference}}" [matDatepicker]="picker" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker>
                    </mat-datepicker>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                        <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}} is
                            required</div>
                    </div>
                </div>
            </div> -->
                    <hr>
                    <h4>Address where the waste is coming from</h4>
                    <app-form-builder formId="address_registration_form" [formData]="" [showSubmit]=false
                        [submitted]="submitted" [maxChildren]="maxChildren" [useCloseButtons]="true"
                        (formStatus)="test($event)"></app-form-builder>
                    <br>
                    <hr>
                    <h4>Vehicle</h4>
                    <app-form-builder formId="vehicle_registration_form" [formData]="" [showSubmit]=false
                        [submitted]="submitted" [maxChildren]="maxChildren" [useCloseButtons]="true"
                        (formStatus)="test($event)"></app-form-builder>
                </form>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <button type="button" class="btn btn-primary govuk-button button-sizer"
                (click)="routerGoBack()">{{'COMMON.BACK' |
                translate}}</button>
        </div>
        <div class="col-6">
            <button class="btn btn-primary govuk-button button-sizer float-right" type="button" (click)="onSubmit()"
                [disabled]="!this.canSubmit">{{'COMMON.REGISTER' |
                translate}}</button>
        </div>
    </div>
    <br>
</div>